<template>
<div id="catalogo_mt">
  <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
  components: {
    "v-power-catalogo": powerCatalogo
  },
  created() {
    window.getApp.$emit("APP_DRAWER_HIDE");
  },

  data: () => ({
    fab: false,
    parametros: {
      url_actions: "apendices/",
      url_list: "apendices/lista/",
      tabla: 34,
      title: "REGÍMENES",
      columns: ["clave", "numero", "nombre", "identificador", "actions"],
      options: {
        filterable: ["clave", "numero", "nombre", "identificador"],
        sortable: ["clave", "numero", "nombre", "identificador"],

        headings: {
          clave: "Clave",
          numero: "Número",
          nombre: "Nombre",
          identificador: "Identificador",
          actions: "Operaciones"
        }
      },
      camposexcel: {
        Clave: "clave",
        Numero: "numero",
        Nombre: "nombre",
        Identificador: "identificador"
      },
      encabezadoLayout: {
        clave: "clave",
        numero: "numero",
        nombre: "nombre",
        identificador: "identificador"
      },
      camposLayout: [{
        clave: "[Clave del regimen]",
        numero: "[Numero del regimen]",
        nombre: "[Nombre del regimen]",
        identificador: "[Identificador del regimen]",
      }],
      model: {
        id: 0,
        clave: "",
        numero:"",
        nombre: "",
        identificador:""
      },
      form: {
        clave: {
          requiered: true,
          label: "Clave",
          value: "",
          maxlen: 50
        },
        numero: {
          requiered: true,
          label: "Número",
          value: "",
          maxlen: 2
        },
        nombre: {
          requiered: true,
          label: "Nombre",
          value: "",
          maxlen: 100
        },
        identificador: {
          requiered: true,
          label: "Identificador",
          value: "",
          maxlen: 2
        }
      },
      breadcrumbs: [{
          text: "Inicio",
          disabled: false,
          to: "/home"
        },
        {
          text: "Utilerías",
          disabled: true,
          to: ""
        },
        {
          text: "Apendices",
          disabled: true,
          to: ""
        }
      ]
    }
  })
};
</script>
<style scoped>
.v-card--material {
  min-height: 750px !important;
}
</style>
<style scoped>
.VueTables>>>thead th {
  white-space: normal !important;
}

.VueTables>>>tbody td {
  white-space: normal !important;
}
</style>
